import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { enqueueSnackbar } from "notistack";
import { useIdleTimerContext } from "react-idle-timer";

import { usePermalinks } from "hooks/usePermalinks";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { SiteDeviceSelection } from "../store/state";

import { coreActions } from "features/core/store/slice";

import * as proto from "src/features/liveStreaming/protobuf/generated/sitedeviceselections_pb";

import { selectDeeplinkSessionConfig } from "features/config/store/selectors";
import { liveStreamingActions } from "../store/slice";

export function LandingPageLiveStream() {
    const dispatch = useAppDispatch();
    const { siteId, "*": deviceIds } = useParams();
    const { start } = useIdleTimerContext();
    const navigate = useNavigate();

    const { encodePermalink } = usePermalinks<SiteDeviceSelection[]>(
        {},
        proto.SiteDeviceSelectionlistSchema,
    );

    const deeplinkSessionConfig = useAppSelector(selectDeeplinkSessionConfig);

    useEffect(() => {
        if (deeplinkSessionConfig?.hideNavigationalElements) {
            dispatch(coreActions.setHideNavigationalElements(true));
        }
    }, [dispatch, deeplinkSessionConfig]);

    useEffect(() => {
        // start the timer for the deeplink session
        start();

        dispatch(
            liveStreamingActions.setSession({
                origin: "landing-page",
                siteId: siteId,
            }),
        );

        const deviceIdsArray = deviceIds ? deviceIds.split("/") : [];

        if (siteId && deviceIdsArray.length > 0) {
            const siteDeviceSelections: SiteDeviceSelection[] = [
                {
                    siteId: Number.parseInt(siteId).toString().padStart(4, "0"),
                    pageNumber: 1,
                    deviceSelectionIsDoneByPaging: false,
                    selectedDevices: deviceIdsArray.map((d) => {
                        return {
                            deviceId: d,
                            properties: { streamQuality: null },
                        };
                    }),
                    devicesWithBadConnection: [],
                },
            ];

            const encodedResult = encodePermalink(siteDeviceSelections);

            if (encodedResult.hasError) {
                enqueueSnackbar(`Could not create Permalink.`, {
                    variant: "error",
                });
                navigate("/livestreaming/", {
                    preventScrollReset: true,
                });
            } else {
                navigate(
                    "/livestreaming/" + encodedResult.base64UrlCompressed,
                    {
                        preventScrollReset: true,
                    },
                );
            }
        } else {
            enqueueSnackbar(
                `Incorrect deeplink. No site or devices provided.`,
                {
                    variant: "error",
                },
            );
            navigate("/livestreaming/", {
                preventScrollReset: true,
            });
        }
    }, [deviceIds, encodePermalink, navigate, siteId]);
    return <></>;
}
